import { bind } from 'bind-decorator';
import React from 'react';

type TIndex = string | number;

interface IProps {
  index: number;

  onClick: (key: TIndex, text: string, e: React.MouseEvent) => void;
}

class QuickPickRawOtherItem extends React.Component<IProps> {
  render() {
    const { index } = this.props;

    return (
      <div className="menu-item" tabIndex={index} onClick={this.onClick}>
        <span className="text">Other</span>
      </div>
    );
  }

  @bind
  onClick(e: React.MouseEvent): void {
    this.props.onClick('Other', 'other', e);
  }
}

export default QuickPickRawOtherItem;
